module.exports = __webpack_public_path__ + "assets/img/2.e9f0fd62.png";